module.exports = __webpack_public_path__ + "static/media/iflip.07d8cdc4.svg";